import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Box, Button, Card, CardContent, Container, Grid, Typography, Divider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../template/Footer";
import HomeIcon from '@mui/icons-material/Home';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PersonIcon from '@mui/icons-material/Person';
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import OpacityIcon from '@mui/icons-material/Opacity';
import "./About.css";

const ForClientPage = ({loader}) => {

    const { authInstance, authUser } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        setLoaded(true);
    },[authInstance, config.saas.permissions]);

    return (
        <>
            {loaded ? (
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="For Clients" />

                    <Box className="about-hero">
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Typography variant="h2" className="hero-title">For Clients</Typography>
                                    <Typography variant="h6" color="text.secondary" className="hero-sub">
                                        Choose the right at-home IV Therapy service for you. Experience personalized care in the comfort of your own space.
                                    </Typography>
                                    <Box sx={{ mt: 3 }}>
                                        <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={() => navigate('/booking')}>Book Now</Button>
                                        <Button variant="outlined" color="secondary" onClick={() => navigate('/contact')}>Contact Us</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Box className="hero-art">
                                        <OpacityIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    <Container sx={{ py: 6 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <HomeIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Convenient Location</Typography>
                                        <Typography color="text.secondary">IV therapy at your home, hotel, or office for maximum convenience.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <MedicalServicesIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Variety of Services</Typography>
                                        <Typography color="text.secondary">Wide range of IV therapy options for wellness and recovery needs.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <PersonIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Personalized Treatment</Typography>
                                        <Typography color="text.secondary">Customized IV therapy treatments tailored to your specific needs.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <VerifiedIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Licensed Nurses</Typography>
                                        <Typography color="text.secondary">All clients are assessed and treated by fully licensed, professional nurses.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 6 }} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>Why Choose Living Waters</Typography>
                                <Typography color="text.secondary">We prioritize your health and convenience, providing high-quality IV therapy services with professional care and personalized attention.</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>Our Commitment</Typography>
                                <ul className="why-list">
                                    <li>Safe, effective IV therapy treatments</li>
                                    <li>Convenient scheduling and locations</li>
                                    <li>Professional, licensed nursing staff</li>
                                    <li>Personalized care for every client</li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Container>

                    <Footer />
                </Container>
            ) : (
                <>{loader}</>
            )}
        </>
    )
}

export default ForClientPage;
